import React from "react";
import "./Dialog.css";

type DialogProps = {
  isOpen: boolean;
  title: string;
  message: string;
  primaryText: string,
  secondaryText: string,
  onPrimary: () => void;
  onSecondary: () => void;
};

const Dialog: React.FC<DialogProps> = ({
  isOpen,
  title,
  message,
  primaryText,
  secondaryText,
  onPrimary,
  onSecondary,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="dialog-container"
      role="dialog"
      aria-labelledby="dialog-title"
      aria-modal="true"
    >
      <div className="bg-white rounded-lg shadow-lg p-6 dialog-body">
        {/* Title */}
        <h4
          id="dialog-title"
          className="text-xl font-semibold mb-6 m-2 text-left"
        >
          {title}
        </h4>

        <hr className="mb-4" />

        {/* Message */}
        <p
          className="mb-6 text-gray-700 m-2"
          style={{
            textAlign: "left",
            marginBottom: "1.5rem",
            lineHeight: "1.5",
            wordWrap: "break-word",
          }}
        >
          {message}
        </p>

        <hr className="mb-4" />

        {/* Buttons */}
        <div className="flex justify-end gap-2">
          <button
            onClick={onSecondary}
            className="px-4 py-2 btn btn-secondary rounded-lg m-2"
            style={{
              minWidth: "80px",
            }}
          >
            {secondaryText}
          </button>
          <button
            onClick={onPrimary}
            className="px-4 py-2 btn btn-primary rounded-lg m-2"
            style={{
              minWidth: "80px",
            }}
          >
            {primaryText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
